<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10"></md-layout>
          <md-layout md-flex="35"></md-layout>
          <md-layout md-flex="40">
            <h2>User Profile</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />
        <md-layout md-gutter v-if="this.UserPersonalDetail.userId != ''">
          <md-layout md-flex="80"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              style=" margin-top"
              @click="reset('dialog2')"
              >Reset Password</md-button
            >
          </md-layout>
        </md-layout>
        <md-dialog
          class="HereDialogPass"
          style
          md-open-from="#custom"
          md-close-to="#custom"
          ref="dialog2"
          :md-click-outside-to-close="false"
        >
          <md-dialog-content>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <label>
                  <u>Reset Password</u>
                </label>
              </md-layout>
              <md-layout md-flex="5">
                <md-button
                  class="md-raised md-dense modal-close-btnn modalClose"
                  @click="closeModal()"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <label>New Password</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  class="md-has-password"
                  type="password"
                  id="newPassword"
                  name="newPassword"
                  v-model="PasswordModal.newPassword"
                  @keyup="samePassword"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <label>Confirm Password</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  type="password"
                  id="confPassword"
                  name="confPassword"
                  v-model="PasswordModal.confPassword"
                  @keyup="samePassword"
                ></b-form-input>
                <span class="error" v-if="PasswordModal.passNotMatchErr != ''">{{
                  passNotMatchErr
                }}</span>
              </md-layout>
            </md-layout>
          </md-dialog-content>

          <md-dialog-actions>
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              @click="updatePassword"
              >Reset</md-button
            >
          </md-dialog-actions>
        </md-dialog>

        <md-dialog-alert
          :md-content="alert.content"
          :md-ok-text="alert.ok"
          ref="addPopDia"
        ></md-dialog-alert>
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>
              <u>User Details</u>
            </label>
            <md-layout md-flex="10"></md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Employee Name</label>
              <b-form-input
                :formatter="capitalizeAll"
                disabled
                id="employeeName"
                name="employeeName"
                v-model="UserPersonalDetail.employeeName"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!UserPersonalDetail.employeeName">{{
              userErrorList.employeeName
            }}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Employee Code</label>
              <b-form-input
                :formatter="capitalizeAll"
                id="employeeCode"
                name="employeeCode"
                v-model="UserPersonalDetail.employeeCode"
                disabled
              ></b-form-input>
              <span class="error" v-if="!UserPersonalDetail.employeeCode">{{
                userErrorList.employeeCode
              }}</span>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Employee Base Location</label>
              <model-list-select
                :list="baseLocationData"
                v-model="UserPersonalDetail.baseLocation"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Employee Location"
                isDisabled
              ></model-list-select>
              <span class="error" v-if="!UserPersonalDetail.baseLocation">{{
                userErrorList.baseLocation
              }}</span>
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Mobile No.</label>
              <b-form-input
                :formatter="capitalizeAll"
                id="mobileNo"
                name="mobileNo"
                v-model="UserPersonalDetail.mobileNo"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!UserPersonalDetail.mobileNo">{{
              userErrorList.mobileNo
            }}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Landline No.</label>
              <b-form-input
                :formatter="capitalizeAll"
                id="landLineNo"
                name="landLineNo"
                v-model="UserPersonalDetail.landLineNo"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Email (Username)</label>
              <b-form-input
                :formatter="capitalizeAll"
                id="email"
                name="email"
                v-model="UserPersonalDetail.email"
                @keyup="isEmailValid"
                disabled
              ></b-form-input>
              <span class="error" v-if="!UserPersonalDetail.email">{{
                userErrorList.email
              }}</span>
              <span class="error" v-if="UserPersonalDetail.email">{{
                errorEmailFormat
              }}</span>
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Employee Designation</label>
              <model-list-select
                :list="designationData"
                v-model="UserPersonalDetail.designation"
                option-value="designation"
                option-text="designation"
                placeholder="Select Employee Designation"
                isDisabled
              ></model-list-select>
              <span class="error" v-if="!UserPersonalDetail.designation">{{
                userErrorList.designation
              }}</span>
            </md-layout>
          </md-layout>
        </md-layout>
        <hr class="hr-border" />
        <b-row>
          <b-col md="12"
            ><u><b>Preference</b></u></b-col
          >
          <b-col md="3">
            <label for="transportType">Transport Preference</label>
            <model-list-select
              :list="transportTypeList"
              v-model="UserPersonalDetail.transportTypePre"
              option-value="transportTypeVal"
              option-text="transportTypeText"
              placeholder="Select Transport Preferenc"
            ></model-list-select
          ></b-col>
        </b-row>

        <hr
          class="hr-border"
          v-if="
            UserPersonalDetail.designation != 'HOD' &&
            UserPersonalDetail.designation != 'Admin' &&
            UserPersonalDetail.designation != '' &&
            userMasterList.length > 0 &&
            UserPersonalDetail.departmentId1.length > 0
          "
        />
        <md-layout
          md-gutter
          class="gutr"
          v-if="
            UserPersonalDetail.designation != 'HOD' &&
            UserPersonalDetail.designation != 'Admin' &&
            UserPersonalDetail.designation != '' &&
            userMasterList.length > 0 &&
            UserPersonalDetail.departmentId1.length > 0
          "
        >
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>{{
                this.UserPersonalDetail.designation == "manager"
                  ? "Employee HOD"
                  : "Employee Manager"
              }}</label>
              <model-list-select
                :list="userMasterList"
                v-model="UserPersonalDetail.employeeHODId"
                option-value="userId"
                option-text="employeeName"
                :placeholder="
                  UserPersonalDetail.designation == 'manager'
                    ? 'Select HOD'
                    : 'Select Manager'
                "
                isDisabled
              ></model-list-select>
              <span class="error" v-if="!UserPersonalDetail.employeeHODId">{{
                employeeHodError
              }}</span>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="gutr" v-if="this.NoteArray == true">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="50">
            <h4 class="error" v-if="UserPersonalDetail.designation != 'manager'">
              Note:-You Do Not Have Any Manager For Selected Employee Department..!
            </h4>
            <h4 class="error" v-else>
              Note:-You Do Not Have Any HOD For Selected Manager Department..!
            </h4>
          </md-layout>
        </md-layout>
        <hr
          class="hr-border"
          v-if="
            UserPersonalDetail.designation != 'HOD' &&
            UserPersonalDetail.designation != 'Admin' &&
            UserPersonalDetail.designation != '' &&
            userMasterList.length > 0 &&
            UserPersonalDetail.departmentId1.length > 0
          "
        />

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="45"></md-layout>
          <md-layout md-flex="45">
            <h4 style="color: red">
              {{ error.message.length > 0 ? error.message : "" }}
            </h4>
            <md-button
              class="md-raised md-primary md-button-color"
              id="addButtonLoader"
              @click="addUser"
              >Update Profile</md-button
            >
            <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
          </md-layout>
        </md-layout>

        <hr class="hr-border" v-if="UserPersonalDetail.designation != ''" />

        <md-layout md-gutter v-if="UserPersonalDetail.designation != ''">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="10">
            <label style="margin-top: 15px">
              <u>Department</u>
            </label>
            <span class="error" v-if="UserPersonalDetail.departmentId1.length == 0">{{
              employeeDepartmentErr
            }}</span>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="gutr" v-if="UserPersonalDetail.designation != ''">
          <md-layout
            v-for="(segmentNameArray, index) in showSegmentArrayList"
            :key="index"
            :md-flex="30"
          >
            <md-layout md-flex="15" v-if="index == 0 || index % 3 == 0"></md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-checkbox
              v-model="UserPersonalDetail.employeeDepartment[index]"
              class="md-primary"
              :md-value="segmentNameArray.departmentId"
              :name="'employeeDepartment' + (index + 1)"
              :id="'employeeDepartment' + (index + 1)"
              @change="employeeDepartmentSelect(segmentNameArray.departmentId, index)"
              disabled
              >{{ segmentNameArray.departmentName }}</md-checkbox
            >
          </md-layout>
        </md-layout>
        <hr class="hr-border" />

        <md-layout md-gutter v-if="UserPersonalDetail.pagePermision.length > 0">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label style="margin-top: 15px">
              <u>Select Permision</u>
            </label>
          </md-layout>
        </md-layout>
        <div v-if="UserPersonalDetail.pagePermision.length > 0">
          <md-layout
            md-gutter
            class="gutr"
            v-for="(segmentNameArray1, index) in UserPersonalDetail.pagePermision"
            :key="index"
          >
            <md-layout md-flex="100">
              <md-layout md-flex="5"></md-layout>

              <h3>{{ segmentNameArray1.departmentName }}</h3>
            </md-layout>
            <md-layout
              v-for="(segmentNameArray, index1) in segmentNameArray1.pageName"
              :key="index1"
              :md-flex="30"
            >
              <md-layout md-flex="15" v-if="index1 == 0 || index1 % 3 == 0"></md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-checkbox
                class="md-primary"
                v-bind:class="
                  UserPersonalDetail.finalPagePermision.indexOf(segmentNameArray) >= 0
                    ? 'md-checked checkedNew' + segmentNameArray1.pageId + (index1 + 1)
                    : 'checkedNew' + segmentNameArray1.pageId + (index1 + 1)
                "
                :md-value="segmentNameArray"
                :name="'deptMas' + (index1 + 1)"
                :id="'deptMas' + (index1 + 1)"
                @change="
                  employeePageName(segmentNameArray, index1, segmentNameArray1.pageId)
                "
                disabled
                >{{ segmentNameArray }}</md-checkbox
              >
            </md-layout>
          </md-layout>
        </div>
      </md-card-content>
    </md-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/userManagement/addUser");
    this.$router.push({
      path: "/userManagement/userProfile",
    });

    this.getData();
  },

  data() {
    return {
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        }, {
          transportTypeVal: "All",
          transportTypeText: "All",
        },
      ],
      userId:
        this.$sessionsStorage.get("editUserPerId") != ""
          ? this.$sessionsStorage.get("editUserPerId")
          : "",
      allPermission: "",
      isLoading: false,

      genericObject: {},
      passNotMatchErr: "",
      PasswordModal: {
        newPassword: "",
        confPassword: "",
      },
      UserPersonalDetail: {
        userId: "",
        employeeCode: "",
        employeeName: "",
        departmentId1: [],
        transportTypePre: "",

        finalPagePermision: [],

        pagePermision: [],
        landLineNo: "",
        mobileNo: "",
        email: "",
        baseLocation: "",
        designation: "",
        employeeDepartment: [],
        employeeHODId: "",
      },

      pageMasterName: [],
      tempPageMasterName: [],
      deleteId: "",
      idNew: "",
      oldDesignaion: "",
      NoteArray: false,

      error: { message: "" },
      alreadyUser: "",
      errorAlreadyUser: false,
      stateDetail: [],
      userMaster: [],
      tempUserMaster: [],
      showSegmentArray: [],
      tempShowSegmentArray: [],
      designationData: [],
      baseLocationData: [],
      employeeDepartmentSelectVal: false,
      employeeHodError: "",

      validate: true,
      userErrorList: {
        employeeName: "",
        employeeCode: "",
        baseLocation: "",
        mobileNo: "",
        email: "",
        designation: "",
      },
      userError: {
        employeeName: "Enter Employee Name",
        employeeCode: "Enter Employee Code",
        baseLocation: "Select Base Location",
        mobileNo: "Enter Mobile No.",
        email: "Enter Email Address",
        designation: "Select Designation",
      },
      employeeDepartmentErr: "",
      errorEmailFormat: "",
      alert: {
        content:
          this.$sessionsStorage.get("editUserPerId") != "" &&
          this.$sessionsStorage.get("editUserPerId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editUserPerId") != "" &&
          this.$sessionsStorage.get("editUserPerId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editUserPerId") != "" &&
          this.$sessionsStorage.get("editUserPerId") != undefined
            ? "Update"
            : "New",
      },
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},
  watch: {
    UserPersonalDetail: {
      handler: function (newVal, oldVal) {
        if (this.oldDesignaion == "" && this.UserPersonalDetail.designation != "") {
          this.oldDesignaion = this.UserPersonalDetail.designation;

          this.newArray("1");
        } else if (this.oldDesignaion == this.UserPersonalDetail.designation) {
        } else {
          this.oldDesignaion = this.UserPersonalDetail.designation;
          this.UserPersonalDetail.employeeHODId = "";
          this.UserPersonalDetail.departmentId1 = [];

          this.newArray("2");
        }
      },
      deep: true,
    },
  },

  beforeDestroy() {
    this.$sessionsStorage.set("editUserPerId", "");
  },

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,

  },

  computed: {
    userMasterList() {
      return this.userMaster;
    },
    showSegmentArrayList() {
      return this.showSegmentArray;
    },
    transportTypeList() {
      return this.transportTypeName;
    },
  },

  methods: {
    closeModal() {
      (this.PasswordModal.newPassword = ""),
        (this.PasswordModal.confPassword = ""),
        this.$refs["dialog2"].close();
    },
    samePassword() {
      if (
        this.PasswordModal.newPassword != this.PasswordModal.confPassword &&
        this.PasswordModal.confPassword.length > 4
      ) {
        this.passNotMatchErr = "Passwords do not match";
      } else {
        this.passNotMatchErr = "";
      }
    },
    reset() {
      this.$sessionsStorage.set("UpdateUserPassId", this.UserPersonalDetail.userId);
      this.$refs["dialog2"].open();
    },

    updatePassword() {
      if (this.PasswordModal.newPassword <= 4) {
        this.passNotMatchErr = "Password length should be 5 character atleast";
        return false;
      } else {
        this.passNotMatchErr = "";
      }
      if (this.PasswordModal.newPassword != this.PasswordModal.confPassword) {
        this.passNotMatchErr = "Passwords do not match";
        return false;
      } else {
        this.passNotMatchErr = "";
      }
      this.PasswordModal["UpdateUserPassId"] = this.$sessionsStorage.get(
        "UpdateUserPassId"
      );

      let options = {
        method: "POST",
        url: `${URL_BASE}/resetPassword.php`,
        data: JSON.stringify(this.PasswordModal),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            this.getData();

            this.$refs["dialog2"].close();
            this.alert.content = "Password Updated Succesfully";
            this.$refs["addPop"].open();

            this.PasswordModal.newPassword = "";
            this.PasswordModal.confPassword = "";
          }
        })
        .catch((error) => {});
    },

    isEmailValid() {
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.UserPersonalDetail.email)) {
        let arrayNew = this.userMaster.filter((x) => {
          return x.email == this.UserPersonalDetail.email;
        });

        if (arrayNew.length > 0) {
          this.errorEmailFormat = "Email Already Exist";
        } else {
          this.errorEmailFormat = "";
        }
      } else {
        this.errorEmailFormat = "Enter Valid Email";
      }
    },
    backToUser() {
      this.$router.push({
        path: "/userManagement/viewUserDetail",
      });
    },
    validateUser() {
      let validate_new = true;

      Object.keys(this.userErrorList).map((x) => {
        if (this.UserPersonalDetail[x] == "") {
          this.userErrorList[x] = this.userError[x];
          validate_new = false;
        }
      });

      if (this.UserPersonalDetail.departmentId1.length == 0) {
        this.employeeDepartmentErr = "Select Atleast 1 Department";

        validate_new = false;
      } else {
        this.employeeDepartmentErr = "";
      }

      if (
        this.UserPersonalDetail.designation != "HOD" &&
        this.UserPersonalDetail.designation != "Admin" &&
        this.UserPersonalDetail.designation != ""
      ) {
        if (this.UserPersonalDetail.employeeHODId == "") {
          var design =
            this.UserPersonalDetail.designation == "manager" ? "HOD" : "manager";
          this.employeeHodError = "Select " + design;

          validate_new = false;
        } else {
          this.employeeHodError = "";
        }
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addUser() {
      this.validateUser();
      if (this.validate != false) {
        $("#addButtonLoaderSub").css("display", "none");
        $("#loaderSub").css("display", "block");

        //  return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addUsers.php`,
          data: JSON.stringify(this.UserPersonalDetail),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              $("#loaderSub").css("display", "none");
              $("#addButtonLoaderSub").css("display", "block");

              if (this.UserPersonalDetail.userId == "") {
                this.alert.content = "Data Added Successfully";
                this.$refs["addPop"].open();
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    employeeDepartmentSelect(value, index) {
      if (this.UserPersonalDetail.departmentId1.length == 0) {
        this.UserPersonalDetail.departmentId1.push(value);
      } else {
        let i = this.UserPersonalDetail.departmentId1.indexOf(value);
        if (i >= 0) {
          this.UserPersonalDetail.departmentId1.splice(i, 1);
        } else {
          this.UserPersonalDetail.departmentId1.push(value);
        }
      }
      this.newArray("1");
    },

    employeePageName(value, index, pageId) {
      if (this.UserPersonalDetail.finalPagePermision.length == 0) {
        this.UserPersonalDetail.finalPagePermision.push(value);
      } else {
        let i = this.UserPersonalDetail.finalPagePermision.indexOf(value);

        if (i >= 0) {
          $(document).ready(function () {
            $(".checkedNew" + pageId + (index + 1)).removeClass("md-checked");
          });

          this.UserPersonalDetail.finalPagePermision.splice(i, 1);
        } else {
          this.UserPersonalDetail.finalPagePermision.push(value);
        }

        // this.genericObject["permissions" + index];
      }
    },

    newArray(id11) {
      let arrayNew = [];

      if (
        this.UserPersonalDetail.designation == "surveyer" ||
        this.UserPersonalDetail.designation == "superviser"
      ) {
        let arrayNew23 = this.designationData.filter((x) => {
          return x.designation == this.UserPersonalDetail.designation;
        });

        if (arrayNew23.length > 0) {
          let arrapSplit = arrayNew23[0].departmentName.split(",");

          this.showSegmentArray = this.tempShowSegmentArray.filter((y, index) => {
            return arrapSplit.indexOf(y.departmentName) >= 0 ? true : false;
          });
        }
      } else {
        this.showSegmentArray = this.tempShowSegmentArray;
      }

      if (id11 == "2") {
        this.UserPersonalDetail.employeeDepartment = Array(
          this.showSegmentArray.length
        ).fill(false);
      }

      if (
        this.UserPersonalDetail.departmentId1.length > 0 &&
        this.UserPersonalDetail.designation != "HOD"
      ) {
        this.UserPersonalDetail.pagePermision = [];

        this.UserPersonalDetail.departmentId1.map((y) => {
          let arrayCheck = this.pageMasterName.filter((x) => {
            return x.departmentId == y;
          });

          if (arrayCheck.length > 0) {
            let obj = {
              pageId: arrayCheck[0].pageId,
              departmentName: arrayCheck[0].departmentName,
              pageName: arrayCheck[0].pageName.split(","),
            };
            this.UserPersonalDetail.pagePermision.push(obj);
          }
        });

        if (
          this.UserPersonalDetail.designation != "manager" &&
          this.UserPersonalDetail.designation != "HOD"
        ) {
          this.tempUserMaster.map((x, index) => {
            if (x.designation == "manager") {
              let arraynew2 = x.departmentId1.split(",");

              for (let ik = 0; ik < this.UserPersonalDetail.departmentId1.length; ik++) {
                let y = this.UserPersonalDetail.departmentId1[ik];

                let indexNew = arraynew2.indexOf(y);
                if (indexNew >= 0) {
                  this.idNew = "fdsf";
                } else {
                  this.idNew = "";

                  break;
                }
              }

              if (arrayNew.length > 0) {
                if (this.idNew != "") {
                  arrayNew.push(x);
                  this.idNew = "";
                }
              } else {
                if (this.idNew == "") {
                  arrayNew = [];
                } else {
                  arrayNew.push(x);
                  this.idNew = "";
                }
              }
            }
          });
        } else if (this.UserPersonalDetail.designation == "manager") {
          this.tempUserMaster.map((x, index) => {
            if (x.designation == "HOD") {
              let arraynew2 = x.departmentId1.split(",");

              for (let ik = 0; ik < this.UserPersonalDetail.departmentId1.length; ik++) {
                let y = this.UserPersonalDetail.departmentId1[ik];

                let indexNew = arraynew2.indexOf(y);
                if (indexNew >= 0) {
                  this.idNew = "fdsf";
                } else {
                  this.idNew = "";

                  break;
                }
              }

              if (arrayNew.length > 0) {
                if (this.idNew != "") {
                  arrayNew.push(x);
                  this.idNew = "";
                }
              } else {
                if (this.idNew == "") {
                  arrayNew = [];
                } else {
                  arrayNew.push(x);
                  this.idNew = "";
                }
              }
            }
          });
        }

        this.userMaster = arrayNew;
        if (
          this.userMaster.length == 0 &&
          this.UserPersonalDetail.designation != "HOD" &&
          this.UserPersonalDetail.designation != "Admin"
        ) {
          this.NoteArray = true;
        } else {
          this.NoteArray = false;
        }
      } else {
        this.userMaster = this.tempUserMaster;
        this.UserPersonalDetail.pagePermision = [];
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleSizenew").DataTable();
      });
    },

    onClose(type) {},

    getData() {
      this.isLoading = true;
      let type_Size = {
        user: "1",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/userProfile.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            }
            console.log(data);

            if (data.userDetails.length > 0) {
              this.userMaster = data.userDetails;
              this.tempUserMaster = data.userDetails;
            } else {
              this.userMaster = [];
            }

            if (data.departmentMasterData.length > 0) {
              this.showSegmentArray = data.departmentMasterData;
              this.tempShowSegmentArray = data.departmentMasterData;
            } else {
              this.showSegmentArray = [];
            }

            if (data.pageDepartmentMaster.length > 0) {
              this.pageMasterName = data.pageDepartmentMaster;
              // this.tempPageMasterName = data.pageDepartmentMaster;
            } else {
              this.showSegmentArray = [];
            }
            if (data.desinationMasterData.length > 0) {
              if (this.$sessionsStorage.get("designation") == "Admin") {
                this.designationData = data.desinationMasterData;
              } else {
                this.designationData = data.desinationMasterData.filter((x) => {
                  return x.designation != "Admin";
                });
              }
            } else {
              this.designationData = [];
            }
            if (data.baseLocationDetails.length > 0) {
              this.baseLocationData = data.baseLocationDetails;
            } else {
              this.baseLocationData = [];
            }

            if (data.userDataDetails.length > 0) {
              console.log(data, "iuiou");

              Object.keys(this.UserPersonalDetail).map((x) => {
                if (x == "departmentId1" || x == "finalPagePermision") {
                  this.UserPersonalDetail[x] = data.userDataDetails[0][x].split(",");
                } else {
                  this.UserPersonalDetail[x] = data.userDataDetails[0][x] || "";
                }
              });

              this.UserPersonalDetail["employeeDepartment"] = [];

              if (
                this.UserPersonalDetail.designation == "surveyer" ||
                this.UserPersonalDetail.designation == "superviser"
              ) {
                let arrayNew23 = this.designationData.filter((x) => {
                  return x.designation == this.UserPersonalDetail.designation;
                });

                if (arrayNew23.length > 0) {
                  let arrapSplit = arrayNew23[0].departmentName.split(",");

                  this.showSegmentArray = this.tempShowSegmentArray.filter((y, index) => {
                    return arrapSplit.indexOf(y.departmentName) >= 0 ? true : false;
                  });
                }

                this.showSegmentArray.map((x, index) => {
                  let i = this.UserPersonalDetail.departmentId1.indexOf(x.departmentId);

                  i >= 0
                    ? (this.UserPersonalDetail.employeeDepartment[index] = true)
                    : (this.UserPersonalDetail.employeeDepartment[index] = false);
                });
              } else {
                this.showSegmentArray.map((x, index) => {
                  let i = this.UserPersonalDetail.departmentId1.indexOf(x.departmentId);

                  i >= 0
                    ? (this.UserPersonalDetail.employeeDepartment[index] = true)
                    : (this.UserPersonalDetail.employeeDepartment[index] = false);
                });
              }
              this.newArray("1");
            } else {
              this.UserPersonalDetail.employeeCode = data.EmployeeCode;
            }
            this.isLoading = false;

            this.JqueryFun();
          }
        })

        .catch((error) => {});
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 20% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.userPermission {
  color: #0e0052;
}
.md-dialog-container.HereDialogPass.md-theme-default .md-dialog {
  width: 30%;
  height: 43%;
  border-radius: 10px;
}
.modalClose {
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 4px;
  line-height: 32px;
  margin-top: -21px;
  background-color: cyan;
}
</style>



// WEBPACK FOOTER //
// userProfile.vue?e9975b92